<template>

<div style="width:90%; margin:auto;">
  <h1 v-if="time"> Where have the trains been recently? </h1>
  <canvas id="canvas"></canvas>
</div>

</template>


<script>

import moment from 'moment-timezone'
import _ from 'lodash'
import axios from 'axios'
import Chart from 'chart.js'

////////////////////////////////////////////////////////////////////////////
// GLOBALS
////////////////////////////////////////////////////////////////////////////
let stationNames = [
  'NE1 - HarbourFront',
  'NE3 - Outram Park',
  'NE4 - Chinatown',
  'NE5 - Clarke Quay',
  'NE6 - Dhoby Ghaut',
  'NE7 - Little India',
  'NE8 - Farrer Park',
  'NE9 - Boon Keng',
  'NE10 - Potong Pasir',
  'NE11 - Woodleigh',
  'NE12 - Serangoon',
  'NE13 - Kovan',
  'NE14 - Hougang',
  'NE15 - Buangkok',
  'NE16 - Sengkang',
  'NE17 - Punggol'
]

let timeFormat = 'MM/DD/YYYY HH:mm'

let chartColors = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  grey: 'rgb(201, 203, 207)'
}

let colorNames = Object.keys(chartColors)

let color = Chart.helpers.color

////////////////////////////////////////////////////////////////////////////
// vue
////////////////////////////////////////////////////////////////////////////
export default {
  props: ["trainHistoryData", "idToPV"],
  data () {
    return {
      config: null,
      chart: null,
      time: null,
    }
  },
  mounted () {
    this.setupChartConfig()
    let ctx = document.getElementById('canvas').getContext('2d')
    this.chart = new Chart(ctx, this.config)
  },
  methods: {
    setupChartConfig() {
      this.config = {
        type: 'line',
        data: {
          labels: [],
          datasets: []
        },
        options: {
          title: {
            text: 'CCL traintraintrain trial Marey Chart'
          },
          tooltips: {
            mode: 'point',
            axis: 'y',
            callbacks: {
              label: function(tooltipItem, data) {
                return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
              }
            }
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                format: timeFormat,
                tooltipFormat: 'll HH:mm'
              },
              scaleLabel: {
                display: true,
                labelString: 'Date'
              }
            }],
            yAxes: [{
              type: 'category',
              labels: stationNames,
            }]
          },
        }
      }
    },
    updateChartData (data) {
      this.config.data.datasets = []
      for (const [i, history] of data.entries()) {
        if (!history || history.length === 0) continue

        let points = []

        for (const prev_station of history) {
          points.push({
            x: moment(prev_station.timestamp),
            y: prev_station.station
          })
        }

        // Sort the points by time
        points.sort(compare)

        let lineColor = chartColors[colorNames[i % colorNames.length]]
        let newDataset = {
          label: this.idToPV[history[0].train_id],
          lineTension: 0,
          backgroundColor: color(lineColor).alpha(0.5).rgbString(),
          borderColor: lineColor,
          fill: false,
          data: points,
        }
        this.config.data.datasets.push(newDataset)
      }
      return Promise.resolve()
    }
  },
  watch: {
    trainHistoryData: function(newData, oldData) {
      this.time = moment.tz("Singapore")
      this.updateChartData(newData)

      // For first time loading, update with animation
      if (oldData) {
        this.chart.update({
          duration: 0
        })
      } else {
        this.chart.update()
      }
    }
  }
}

////////////////////////////////////////////////////////////////////////////
// Helper functions
////////////////////////////////////////////////////////////////////////////
function compare(a,b) {
  if (a.x < b.x)
    return -1;
  if (a.x > b.x)
    return 1;
  return 0;
}

</script>

<style scoped>

h1 {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Marey.vue